import React from 'react';
import { Navigate, Route, Routes } from 'react-router';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import ChatPromptScreen from './screens/ChatPromptScreen';
import Layout from './components/Layout';
import { generateUUID } from './helpers';
import { persist, store } from './redux/store';
import { ThemeProvider } from './contexts/ThemeContext';

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persist}>
      <ThemeProvider>
        <Routes>
          <Route
            index
            path="/chat/:id"
            element={
              <Layout>
                <ChatPromptScreen />
              </Layout>
            }
          />
          <Route path="*" element={<Navigate to={`/chat/${generateUUID()}`} replace />} />
        </Routes>
      </ThemeProvider>
    </PersistGate>
  </Provider>
);

export default App;
